// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 5901) return "css/5901-d544ebaf.css";
	// return url for filenames based on template
	return "css/" + chunkId + "-" + {"3197":"b271198b","8342":"fbcd00a1"}[chunkId] + ".css";
};